import type { NavbarProps } from "./navbar.types";

export const initialNavbarState: NavbarProps = {
  selectedNavbarItem: "",
  setSelectedNavbarItem: () => {},
};
